import { StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getProgressBarCollectionStyles = progressBarPosition => {
  return StyleSheet.create({
    progressBarCollectionWrapper: Object.assign(Object.assign({}, progressBarPosition != 'bottom' && {
      paddingTop: tokens.spacing.SPACING_16
    }), progressBarPosition != 'bottom' && {
      marginBottom: tokens.spacing.SPACING_16
    })
  });
};